import React from 'react';
import { Tag } from 'antd';
import { APP_ENV } from '../env';

/** Marks the staging site, so nobody mistakes it for the real one. Shown on staging builds only. */
export const EnvBadge: React.FC = () =>
  APP_ENV !== 'staging' ? null : (
    <Tag
      color="orange"
      style={{
        position: 'fixed',
        insetBlockEnd: 12,
        insetInlineStart: 12,
        zIndex: 1000,
        margin: 0,
        fontWeight: 600,
      }}
      data-testid="env-badge"
    >
      Staging
    </Tag>
  );
